import { LandingPageSettingEnum, UserSettingTypesEnum } from '../../utilities/Constants';

import Authorization from '../../stores/Authorization';
import { LandingPageSetting } from './LandingPageSetting';
import { PageWithAffixedHeader } from '../../shared/PageWithAffixedHeader';
import { PreferredOrganization } from './PreferredOrganization';
import { PreferredSameCaseZoneGroup } from './PreferredSameCaseZoneGroup';
import { Stack } from 'react-bootstrap';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGetUserSetting } from './useGetUserSetting';

export function UserSettings() {
    const { user } = useAuthContext();

    const hasAtleastOneNationalDataScope = Authorization.userHasAtleastOneNationalDataScope(user);
    const showPreferredSameCaseZoneGroupSetting = hasAtleastOneNationalDataScope;

    const preferredLandingPageUserSetting = useGetUserSetting(
        UserSettingTypesEnum.PreferredLandingPage
    );

    const isCenterLandingPage =
        preferredLandingPageUserSetting.data?.settingsJson ===
        LandingPageSettingEnum.QuadDashboard.toString();

    return (
        <PageWithAffixedHeader headerComponent={<h1>User Settings</h1>}>
            <Stack gap={2}>
                <LandingPageSetting />
                {preferredLandingPageUserSetting.isFetched && !isCenterLandingPage && (
                    <PreferredOrganization />
                )}
                {showPreferredSameCaseZoneGroupSetting && <PreferredSameCaseZoneGroup />}
            </Stack>
        </PageWithAffixedHeader>
    );
}
